const applications = [
  {
    icon: 'ri-recycle-line',
    title: 'Aterros Sanitários',
    desc: 'Impermeabilização de base e cobertura de aterros sanitários, garantindo contenção segura de chorume e gases conforme normas ambientais vigentes.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Mineração',
    desc: 'Revestimento de pilhas de lixiviação, bacias de contenção e barragens de rejeitos com geomembranas de alta resistência química.',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Reservatórios',
    desc: 'Impermeabilização de reservatórios de água potável, industrial e agrícola com soldas certificadas e duradouras.',
  },
  {
    icon: 'ri-contrast-drop-line',
    title: 'Lagoas',
    desc: 'Revestimento de lagoas de tratamento, decantação e estabilização com geomembranas soldadas in loco.',
  },
  {
    icon: 'ri-anchor-line',
    title: 'Aquicultura',
    desc: 'Tanques e viveiros impermeabilizados para produção de peixes, camarões e outros organismos aquáticos.',
  },
  {
    icon: 'ri-plant-line',
    title: 'Piscicultura',
    desc: 'Sistemas de produção aquícola com geomembrana soldada para máxima eficiência hídrica e sanitária.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Tratamento de Efluentes',
    desc: 'Bacias e lagoas de tratamento de efluentes industriais e domésticos com barreira impermeabilizante confiável.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Irrigação',
    desc: 'Canais e reservatórios de irrigação revestidos com geomembrana para eliminar perdas por infiltração.',
  },
];

export default function ApplicationsSection() {
  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <span className="text-green-600 text-xs font-black uppercase tracking-[0.2em]">
            Onde Utilizar
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 uppercase mt-3 mb-4">
            Aplicações
          </h2>
          <p className="text-gray-500 text-sm max-w-xl mx-auto leading-relaxed">
            As máquinas de solda de geomembrana atendem os mais diversos segmentos da engenharia e construção.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {applications.map((app) => (
            <div
              key={app.title}
              className="group bg-white rounded-2xl p-5 border border-gray-100 hover:border-green-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-green-50 rounded-xl mb-4 group-hover:bg-green-100 transition-colors">
                <i className={`${app.icon} text-green-600 text-lg`} />
              </div>
              <h3 className="text-sm font-black text-gray-900 uppercase mb-2">{app.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed">{app.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}